import React, { Fragment, useState, useContext, useEffect, useRef } from 'react'
import { Link as RouteLink } from "react-router-dom";
import * as XLSX from 'xlsx';

import {
    Box,
    Link,
    Container,
    Skeleton,
    Stack,
    Text,
    Heading,
    Button,
    Table,
    IconButton,
    Tr,
    Th,
    Td,
    Thead,
    Tbody,
    Center,
    Input,
    FormControl,
    FormLabel,
    Tooltip,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalCloseButton,
    useDisclosure,
    useToast,

    HStack,
    Avatar,
    FormErrorMessage,
    Flex,

} from '@chakra-ui/react'
import { MdClose } from 'react-icons/md'
import { BiUserPlus } from 'react-icons/bi'
import { FaTrashAlt, FaPencilAlt } from "react-icons/fa"

import {
    AutoComplete,
    AutoCompleteInput,
    AutoCompleteItem,
    AutoCompleteList,
} from '@choc-ui/chakra-autocomplete'
import { DragHandleIcon } from '@chakra-ui/icons'
import { EditIcon, DeleteIcon, DownloadIcon, AttachmentIcon } from '@chakra-ui/icons'
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import { useMutation, useQuery } from '@apollo/client'
import { useMultiState } from '../lib/hooks'
import { useTranslation } from 'react-i18next'
import AuthContext from '../contexts/AuthContext'
import { useHistory } from 'react-router'

import DialogRemove from '../components/commons/DialogRemove'
import DialogCreateStudent from '../components/pages/ManageStudentPage/DialogCreateStudent'
import DialogUpdateStudent from '../components/pages/ManageStudentPage/DialogUpdateStudent';


import UpdateMutaion from "../graphql/mutations/updateStudentUser"
import RemoveStudentMutaion from "../graphql/mutations/removeStudentUser"
import setPasswordMutation from '../graphql/mutations/setPassword'
import studentQuery from '../graphql/queries/studentUser'
import createStudentMutation from '../graphql/mutations/createStudentUser'
import axios from "axios"

const initialStudent = {
    _id: '',
    username: '',
    firstname: '',
    lastname: '',
    mobile: '',
    email: '',
    avatar: '',
    password: '',
    confirm_pass: '',
    confirm_email: '',
}

const URL = process.env.REACT_APP_UPLOAD_IMAGE
const API_BASE_URL = (
    process.env.REACT_APP_URL_PUBLIC ||
    (process.env.REACT_APP_GRAPHQL_SERVER || '').replace('/graphql', '')
).replace(/\/$/, '')
const GENERATE_STUDENT_URL = `${API_BASE_URL}/generate/student`

const pickFirstValue = (row, keys) => {
    for (const key of keys) {
        if (row[key] !== undefined && row[key] !== null && row[key] !== '') return row[key]
    }
    return ''
}

const normalizeImportStudentRow = (row) => {
    const firstname = pickFirstValue(row, ['firstname', 'firstName', 'First Name', 'ชื่อ', 'ชื่อจริง'])
    const lastname = pickFirstValue(row, ['lastname', 'lastName', 'Last Name', 'นามสกุล', 'สกุล'])
    const mobile = String(pickFirstValue(row, ['mobile', 'phone', 'tel', 'เบอร์', 'เบอร์โทร', 'เบอร์โทรศัพท์'])).trim()
    const email = String(pickFirstValue(row, ['email', 'Email', 'อีเมล', 'อีเมล์'])).trim()
    const username = String(pickFirstValue(row, ['username', 'Username', 'ชื่อผู้ใช้'])).trim() || email || mobile

    return {
        firstname: String(firstname || '').trim(),
        lastname: String(lastname || '').trim(),
        mobile,
        email,
        username,
    }
}

const validateImportStudentRows = (rows, existingUsers = []) => {
    const seen = new Set()
    return rows.map((row, index) => {
        const username = row.username || row.email || row.mobile
        const key = `${username}|${row.mobile}|${row.email}`
        const errors = []
        const exists = existingUsers.some((user) =>
            (username && user.username === username) ||
            (row.mobile && user.mobile === row.mobile) ||
            (row.email && user.email === row.email)
        )

        if (!row.firstname) errors.push('ไม่มี firstname')
        if (!row.lastname) errors.push('ไม่มี lastname')
        if (!row.mobile) errors.push('ไม่มี mobile')
        if (row.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(row.email)) errors.push('email ไม่ถูกต้อง')
        if (seen.has(key)) errors.push('ข้อมูลซ้ำในไฟล์')
        if (exists) errors.push('มีผู้ใช้นี้ในระบบแล้ว')
        seen.add(key)

        return {
            ...row,
            username,
            rowNumber: row.rowNumber || index + 2,
            exists,
            errors,
            ready: errors.length === 0,
        }
    })
}

const ManageStudentPage = () => {
    const { t } = useTranslation()
    const history = useHistory()
    const { user } = useContext(AuthContext)
    const toast = useToast()
    const importInputRef = useRef(null)

    const [setPassword] = useMutation(setPasswordMutation)
    const [updateMutation] = useMutation(UpdateMutaion)
    const [removeStudentMutaion] = useMutation(RemoveStudentMutaion)
    const [setStudentUser] = useMutation(createStudentMutation)
    const { data: studentData, refetch, loading } = useQuery(studentQuery)

    const [student, setStudent] = useMultiState(initialStudent)
    const [studentState, setStudentState] = useState([])
    const [passwordEditStatus, setPasswordEditStatus] = useState(false)
    const [updateFormError, setUpdateFormError] = useState(null);
    const [isImportingStudents, setIsImportingStudents] = useState(false)
    const [studentImportPreviewRows, setStudentImportPreviewRows] = useState([])

    const { isOpen: updateDialogStatus, onOpen: openUpdateDialogStatus, onClose: closeUpdateDialogStatus } = useDisclosure()
    const { isOpen: createDialogStatus, onOpen: openCreateDialogStatus, onClose: closeCreateDialogStatus, } = useDisclosure()
    const { isOpen: removeDialogStatus, onOpen: openRemoveDialogStatus, onClose: closeRemoveDialogStatus } = useDisclosure()
    const { isOpen: importPreviewDialog, onOpen: openImportPreviewDialog, onClose: closeImportPreviewDialog } = useDisclosure()


    useEffect(() => {
        if (studentData) {
            setStudentState(studentData?.studentUsers ? studentData?.studentUsers : [])
        }
        if (user?.role !== 'ADMIN') {
            setTimeout(() => {
                history.push('/login')
            }, 100)
        }
        if (loading) {
            refetch({
                user: user?._id,
            })
        }
    }, [studentData, history, user, refetch]);



    const [fileavatar, setFileAvatar] = useMultiState({ data: null, base64: '' })

    const selectAvatarFile = (e) => new Promise((resolve, reject) => {
        e.preventDefault()
        const file = e.currentTarget.files[0]
        setFileAvatar({ data: file })
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
            resolve(reader.result)
            setFileAvatar({ base64: reader.result })
        }
        reader.onerror = (error) => reject(error)
    })

    const handleCreateStudent = async (e) => {
        e.preventDefault()
        if (!student?.username) {
            await toast({
                position: "top",
                title: "Warning",
                description: `${t('ManageStudentPage.altwarningUsername')}`,
                status: 'warning',
                duration: 6000,
                isClosable: true,
            })
        } else if (!student?.firstname) {
            await toast({
                position: "top",
                title: "Warning",
                description: `${t('ManageStudentPage.altwarningName')}`,
                status: 'warning',
                duration: 6000,
                isClosable: true,
            })
        } else if (!student?.lastname) {
            await toast({
                position: "top",
                title: "Warning",
                description: `${t('ManageStudentPage.altwarningLastname')}`,
                status: 'warning',
                duration: 6000,
                isClosable: true,
            })
        } else {
            try {
                const response = await axios.post(URL, { photo: fileavatar.base64 })
                // console.log(response)
                const { data: responseCreateStudent, } = await setStudentUser({
                    variables: {
                        firstname: student?.firstname,
                        lastname: student?.lastname,
                        mobile: student?.mobile,
                        username: student?.username,
                        email: student?.email,
                        avatar: response ? response?.data?.url : '',
                    },
                })
                if (responseCreateStudent) {
                    const { data: responseSetPassword, } = await setPassword({
                        variables: {
                            _id: responseCreateStudent?.createStudentUser?.recordId,
                            password: student?.password,
                        },
                    })
                    if (responseSetPassword) {
                        // console.log('finally')
                        await toast({
                            position: "top",
                            title: 'Success',
                            description: `${t('ManageStudentPage.toastAddTeacherSuccess')}`,
                            status: 'success',
                            duration: 6000,
                            isClosable: true,
                        })
                        closeCreateDialogStatus()

                    }
                }
            } catch (Error) {
                await toast({
                    position: "top",
                    title: "ERROR",
                    description: `${Error?.graphQLErrors[0]?.message}`,
                    status: "error",
                    duration: 6000,
                    isClosable: true,
                })
                // enqueueSnackbar(Error, { variant: 'error' })
            }
            refetchPage()
        }
    }

    const handleUpdateStudent = async (e) => {
        e.preventDefault();
        // const response = await axios.post(URL, { photo: fileavatar.base64 })
        try {
            if (passwordEditStatus) {
                if (!student?.password) {
                    setUpdateFormError('กรุณากรอกรหัสผ่านใหม่');
                    return;
                }
                if (student?.password !== student?.confirm_pass) {
                    setUpdateFormError('รหัสผ่านไม่ตรงกัน');
                    return;
                }
            }

            const { data: responseUpdateStudent } = await updateMutation({
                variables: {
                    _id: student?._id,
                    firstname: student?.firstname,
                    lastname: student?.lastname,
                    mobile: student?.mobile,
                    username: student?.username,
                    email: student?.email,
                },
            })
            if (responseUpdateStudent) {
                if (passwordEditStatus) {
                    await setPassword({
                        variables: {
                            _id: student?._id,
                            password: student?.password,
                        },
                    })
                }
                await toast({
                    position: "top",
                    title: "Success",
                    description: `${t('ManageStudentPage.toastEditTeacherSuccess')}`,
                    status: "success",
                    duration: 6000,
                    isClosable: true,
                })
                setUpdateFormError(null); // Clear error on success
                setPasswordEditStatus(false)
                setStudent({ password: '', confirm_pass: '' })
                closeUpdateDialogStatus()
                refetchPage() // Call refetchPage on success
            }
        } catch (error) {
            console.log("Error in handleUpdateStudent:", error); // Keep console log for debugging
            let errorMessage = "An unexpected error occurred. Please try again."; // Default message

            if (error.graphQLErrors && error.graphQLErrors.length > 0) {
                errorMessage = error.graphQLErrors[0].message;
            } else if (error.networkError) {
                // Handle network errors specifically if needed, or fall back to generic
                if (error.networkError.result && error.networkError.result.errors && error.networkError.result.errors.length > 0) {
                    errorMessage = error.networkError.result.errors[0].message;
                } else if (error.networkError.message) {
                    errorMessage = error.networkError.message;
                } else {
                    errorMessage = "A network error occurred. Please check your connection.";
                }
            } else if (error.message) {
                errorMessage = error.message;
            }

            setUpdateFormError(errorMessage); 
        }
        // refetchPage() // Removed from here, called only on success
    }

    const handleRemoveStudent = async (e) => {
        e.preventDefault()
        try {
            const { data: responseRemoveStudent } = await removeStudentMutaion({
                variables: {
                    _id: student?._id,
                }
            })
            if (responseRemoveStudent) {
                await toast({
                    position: "top",
                    title: "Success",
                    description: `${t('ManageStudentPage.toastAddSuccessRemove')}`,
                    status: "success",
                    duration: 3000,
                    isClosable: true,
                })
                closeRemoveDialogStatus()
            }
        } catch (error) {
            console.log(error)
            await toast({
                position: "top",
                title: "Success",
                description: `${t(error)}`,
                status: "success",
                duration: 3000,
                isClosable: true,
            })
        }
        refetchPage()
    }

    const toggleEditPasswordStatus = () => {
        console.log("ACTIVE1", passwordEditStatus)
        setPasswordEditStatus(!passwordEditStatus)
    }
    console.log("ACTIVE2", passwordEditStatus)

    const refetchPage = () => {
        refetch()
        setStudent(initialStudent)
        setFileAvatar({ data: null, base64: '' })
    }

    const readStudentImportWorkbook = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = (event) => {
                try {
                    resolve(XLSX.read(event.target.result, { type: 'array' }))
                } catch (error) {
                    reject(error)
                }
            }
            reader.onerror = reject
            reader.readAsArrayBuffer(file)
        })

    const handleDownloadImportTemplate = () => {
        const rows = [
            {
                firstname: 'Somchai',
                lastname: 'Jaidee',
                mobile: '0812345678',
                email: 'somchai@example.com',
                username: '',
            },
        ]
        const worksheet = XLSX.utils.json_to_sheet(rows)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Students')
        XLSX.writeFile(workbook, 'student_import_template.xlsx')
    }

    const handleImportStudents = async (event) => {
        const file = event.target.files?.[0]
        if (!file) return

        try {
            const workbook = await readStudentImportWorkbook(file)
            const worksheet = workbook.Sheets[workbook.SheetNames[0]]
            const rows = XLSX.utils.sheet_to_json(worksheet, { defval: '' })
            const data = rows
                .map((row, index) => ({ ...normalizeImportStudentRow(row), rowNumber: index + 2 }))
                .filter((row) => row.firstname && row.lastname && row.mobile)

            if (data.length === 0) {
                toast({
                    position: 'top',
                    title: 'ไม่พบข้อมูลที่นำเข้าได้',
                    description: 'ไฟล์ต้องมีอย่างน้อย firstname, lastname และ mobile',
                    status: 'warning',
                    duration: 6000,
                    isClosable: true,
                })
                return
            }

            setStudentImportPreviewRows(validateImportStudentRows(data, studentData?.studentUsers || []))
            openImportPreviewDialog()
        } catch (error) {
            toast({
                position: 'top',
                title: 'Import students ไม่สำเร็จ',
                description: error?.response?.data?.message || error.message,
                status: 'error',
                duration: 7000,
                isClosable: true,
            })
        } finally {
            event.target.value = ''
        }
    }

    const updateStudentImportPreviewRow = (index, field, value) => {
        const nextRows = studentImportPreviewRows.map((row, rowIndex) =>
            rowIndex === index ? { ...row, [field]: value, username: field === 'email' || field === 'mobile' ? row.username : row.username } : row
        )
        setStudentImportPreviewRows(validateImportStudentRows(nextRows, studentData?.studentUsers || []))
    }

    const handleConfirmImportStudents = async () => {
        const invalidRows = studentImportPreviewRows.filter((row) => !row.ready)
        if (invalidRows.length > 0) {
            toast({
                position: 'top',
                title: 'ยังไม่สามารถสร้างผู้ใช้ได้',
                description: `พบข้อมูลไม่ถูกต้องหรือซ้ำ ${invalidRows.length} แถว กรุณาแก้ไฟล์ Excel แล้ว import เข้ามาใหม่`,
                status: 'warning',
                duration: 7000,
                isClosable: true,
            })
            return
        }

        const readyRows = studentImportPreviewRows.filter((row) => row.ready).map(({ rowNumber, exists, errors, ready, ...row }) => row)
        if (readyRows.length === 0) {
            toast({
                position: 'top',
                title: 'ไม่มีรายการที่พร้อมสร้าง',
                description: 'กรุณาแก้ไฟล์ Excel แล้ว import เข้ามาใหม่',
                status: 'warning',
                duration: 5000,
                isClosable: true,
            })
            return
        }

        setIsImportingStudents(true)
        try {
            const response = await axios.post(GENERATE_STUDENT_URL, { data: readyRows })
            const created = response?.data?.created || 0
            const skipped = response?.data?.skipped?.length || 0
            toast({
                position: 'top',
                title: 'Import students สำเร็จ',
                description: `สร้างผู้ใช้ใหม่ ${created} คน${skipped ? `, ข้าม ${skipped} รายการ` : ''} โดยรหัสผ่านตั้งเป็นเบอร์โทร`,
                status: skipped ? 'warning' : 'success',
                duration: 7000,
                isClosable: true,
            })
            closeImportPreviewDialog()
            setStudentImportPreviewRows([])
            refetchPage()
        } catch (error) {
            toast({
                position: 'top',
                title: 'Import students ไม่สำเร็จ',
                description: error?.response?.data?.message || error.message,
                status: 'error',
                duration: 7000,
                isClosable: true,
            })
        } finally {
            setIsImportingStudents(false)
        }
    }

    const handleCloseUpdateDialog = () => {
        closeUpdateDialogStatus(); // This is the original onClose from useDisclosure
        setStudent(initialStudent); 
        setFileAvatar({ data: null, base64: '' }); 
        setPasswordEditStatus(false); 
    };

    return (
        <Fragment>
            <Modal isOpen={importPreviewDialog} onClose={closeImportPreviewDialog} size="6xl">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>ตรวจสอบรายชื่อก่อนสร้างผู้ใช้</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text mb={3}>
                            รายการที่พร้อมสร้าง: {studentImportPreviewRows.filter((row) => row.ready).length} / {studentImportPreviewRows.length}
                        </Text>
                        {studentImportPreviewRows.some((row) => !row.ready) ? (
                            <Text mb={3} color="red.600" fontSize="sm">
                                พบข้อมูลซ้ำหรือไม่ผ่านเงื่อนไขการสร้างผู้ใช้ ระบบจะไม่บันทึกทั้งไฟล์ กรุณาแก้ไขไฟล์ Excel แล้ว import ใหม่
                            </Text>
                        ) : null}
                        <Box overflowX="auto">
                            <Table size="sm" variant="simple">
                                <Thead>
                                    <Tr>
                                        <Th>แถว</Th>
                                        <Th>firstname</Th>
                                        <Th>lastname</Th>
                                        <Th>mobile</Th>
                                        <Th>email</Th>
                                        <Th>username</Th>
                                        <Th>สถานะ</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {studentImportPreviewRows.map((row, index) => (
                                        <Tr key={`${row.rowNumber}-${index}`} bg={row.ready ? 'green.50' : 'red.50'}>
                                            <Td>{row.rowNumber}</Td>
                                            <Td>
                                                <Input size="sm" value={row.firstname} isReadOnly />
                                            </Td>
                                            <Td>
                                                <Input size="sm" value={row.lastname} isReadOnly />
                                            </Td>
                                            <Td>
                                                <Input size="sm" value={row.mobile} isReadOnly />
                                            </Td>
                                            <Td>
                                                <Input size="sm" value={row.email} isReadOnly />
                                            </Td>
                                            <Td>
                                                <Input size="sm" value={row.username} isReadOnly />
                                            </Td>
                                            <Td>
                                                <Text color={row.ready ? 'green.700' : 'red.700'} fontSize="sm">
                                                    {row.ready ? 'พร้อมสร้าง' : row.errors.join(', ')}
                                                </Text>
                                            </Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </Box>
                    </ModalBody>
                    <ModalFooter>
                        <Button mr={3} onClick={closeImportPreviewDialog}>
                            ยกเลิก
                        </Button>
                        <Button
                            colorScheme="green"
                            isLoading={isImportingStudents}
                            isDisabled={studentImportPreviewRows.some((row) => !row.ready)}
                            onClick={handleConfirmImportStudents}
                        >
                            ยืนยันสร้างผู้ใช้
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
            <Container maxW={'7xl'} py={5} as={Stack} minH={'90vh'} mt={5} w="100%">
                <Stack spacing={0} align={'center'} >
                    <Heading variant="h4">{t('ManageStudentPage.title')}</Heading>
                    <Text>{t('ManageStudentPage.subtitle')}</Text>
                </Stack>
                <Flex
                    py={2}
                    direction={["column", "", "row"]}
                    justifyContent='space-between'

                >
                    <Stack align={{ base: 'center', md: "flex-end" }}>
                        <Flex
                            boxSize="full"
                            // h="100vh"
                            w={['90%', '', '400px']}
                            pos="relative"
                            // bg={useColorModeValue("gray.400", "gray.600")}
                            // p={30}
                            alignItems='center'
                            justifyContent="center">
                            <AutoComplete
                                onChange={(v, i, I) => {
                                    // console.log(v, i, I);
                                }}
                                onSelectOption={(e) => { setStudentState(studentState?.filter((row) => (e?.optionValue === row?._id))) }}
                                rollNavigation>
                                <AutoCompleteInput size='lg' variant="filled" placeholder="Search..." autoFocus />
                                <AutoCompleteList>

                                    {studentData?.studentUsers.map((option, oid) => (
                                        <AutoCompleteItem
                                            key={`option-${oid}`}
                                            label={`${option?.firstname} ${option?.lastname}`}
                                            value={`${option?._id}`}
                                            textTransform="capitalize"
                                        >
                                            {` ${option?.firstname} ${option?.lastname} `}
                                        </AutoCompleteItem>
                                    ))}
                                </AutoCompleteList>
                            </AutoComplete>
                            <IconButton
                                variant="ghost"
                                colorScheme='blue'
                                pos='absolute'
                                right={0}
                                aria-label="Call Sage"
                                fontSize="15px"
                                onClick={() => { setStudentState(studentData?.studentUsers) }}
                                icon={<MdClose />}
                            />
                        </Flex>
                    </Stack>
                    <HStack mb={3}>
                        <input
                            ref={importInputRef}
                            type="file"
                            accept=".xlsx,.xls"
                            style={{ display: 'none' }}
                            onChange={handleImportStudents}
                        />
                        <Button
                            leftIcon={<DownloadIcon />}
                            size='lg'
                            variant='outline'
                            onClick={handleDownloadImportTemplate}
                        >
                            Template
                        </Button>
                        <Button
                            leftIcon={<AttachmentIcon />}
                            size='lg'
                            colorScheme='green'
                            variant='outline'
                            isLoading={isImportingStudents}
                            onClick={() => importInputRef.current?.click()}
                        >
                            Import Excel
                        </Button>
                        <Button
                            bg={'primary.700'} color={'white'} _hover={{
                                transform: 'translateY(-2px)',
                                boxShadow: 'lg',
                            }}
                            leftIcon={<BiUserPlus />}
                            size='lg'
                            onClick={openCreateDialogStatus}
                        >
                            {t('ManageStudentPage.addTeacherButton')}
                        </Button>
                    </HStack>
                </Flex>
                {loading ?
                    <Stack py={20}>
                        <Skeleton height='20px' />
                        <Skeleton height='20px' />
                        <Skeleton height='20px' />
                    </Stack>
                    :
                    <Box sx={{ overflowX: ['auto', 'auto', 'none'], maxW: ['350px', 'none'] }} boxShadow={'xl'} borderWidth={'1px'}  >
                        <Table variant="striped" backgroundColor="white">
                            <Tr>
                                <Th textAlign="center">	{t('ManageStudentPage.no')}</Th>
                                <Th textAlign="center">{t('ManageStudentPage.name-surname')} </Th>
                                <Th textAlign="center">{t('ManageStudentPage.manage')}</Th>
                            </Tr>
                            {studentState?.map((student, i) => (
                                <Tbody>
                                    {console.log("SS", student)
                                    }
                                    <Tr key={student?._id}>
                                        <Td textAlign="center">{i + 1}</Td>
                                        <Td textAlign="center">
                                            <Link as={RouteLink} isExternal to={`/showprofile/${student?._id}`} >
                                                {student?.firstname} {student?.lastname}
                                            </Link>
                                        </Td>
                                        <Td>
                                            <Center>
                                                <Tooltip label={t('ManageStudentPage.editButton')} fontSize="md">
                                                    <IconButton boxShadow={'lg'} colorScheme='blue' icon={<FaPencilAlt />} mr={2}
                                                        _hover={{
                                                            transform: 'translateY(-2px)',
                                                            boxShadow: 'lg',
                                                        }}
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            setStudent({
                                                                _id: student?._id,
                                                                username: student?.username,
                                                                firstname: student?.firstname,
                                                                lastname: student?.lastname,
                                                                mobile: student?.mobile,
                                                                email: student?.email,
                                                                avatar: student?.avatar,
                                                                password: '',
                                                                confirm_pass: '',
                                                            })
                                                            setPasswordEditStatus(false)
                                                            setUpdateFormError(null);
                                                            openUpdateDialogStatus()
                                                        }}
                                                    />
                                                </Tooltip>
                                                <Tooltip label={t('ManageStudentPage.removeButton')} fontSize="md">
                                                    <IconButton boxShadow={'lg'} colorScheme='red' icon={<FaTrashAlt />} mr={2}
                                                        _hover={{
                                                            transform: 'translateY(-2px)',
                                                            boxShadow: 'lg',
                                                        }}
                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            setStudent({
                                                                _id: student?._id,
                                                                username: student?.username,
                                                                firstname: student?.firstname,
                                                                lastname: student?.lastname,
                                                                mobile: student?.mobile,
                                                                email: student?.email,
                                                                avatar: student?.avatar,
                                                            })
                                                            openRemoveDialogStatus()
                                                        }}
                                                    />
                                                </Tooltip>
                                            </Center>
                                        </Td>
                                    </Tr>
                                </Tbody>))}
                        </Table>
                    </Box>
                }
            </Container>
            <DialogRemove
                status={removeDialogStatus}
                handleSubmit={handleRemoveStudent}
                name={`${student.firstname} ${student.lastname}`}
                onCloseDialog={closeRemoveDialogStatus}
            />

            <DialogCreateStudent
                student={student}
                setStudent={setStudent}
                createDialogStatus={createDialogStatus}
                closeCreateDialogStatus={closeCreateDialogStatus}
                handleCreateStudent={handleCreateStudent}
                selectAvatarFile={selectAvatarFile}
            />
            <DialogUpdateStudent
                passwordEditStatus={passwordEditStatus}
                toggleEditPasswordStatus={toggleEditPasswordStatus}
                student={student}
                setStudent={setStudent}
                updateDialogStatus={updateDialogStatus}
                closeUpdateDialogStatus={handleCloseUpdateDialog}
                handleUpdateStudent={handleUpdateStudent}
                selectAvatarFile={selectAvatarFile}
                updateFormError={updateFormError}
            />
        </Fragment >
    )
}

export default ManageStudentPage
